module.exports = __webpack_public_path__ + "static/media/mail.d7a1ed53.svg";